import { TooltipIcon } from '@ipfabric/ui-components/Tooltip/TooltipIcon';
import { FormikTextField } from 'components/FormikTextField/FormikTextField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface SlugValues {
  slug?: string;
}

interface Props<T extends SlugValues> {
  formik: FormikProps<T>;
}

export const FormikVendorApiSlugField = <T extends SlugValues>(
  props: Props<T>,
): JSX.Element => {
  const {
    discoverySettings: {
      vendorsApi: { labels: labelsMsg },
    },
  } = useLocale();
  return (
    <FormikTextField
      formik={props.formik}
      name='slug'
      label={
        <>
          {labelsMsg.slug}
          <TooltipIcon
            content={labelsMsg.slugTooltip}
            iconProps={{
              iconStyle: 'solid',
              inline: true,
            }}
            className='ml-2'
            size='sm'
          />
        </>
      }
      type='text'
    />
  );
};
